import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import {Employee } from '../interfaces/employee.interface';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {

  private getemployeecodesUrl = environment.apiUrl + '/handlers/employeesgetall.php';
  private createemployeeUrl = environment.apiUrl + '/handlers/employeecreate.php';
  private updateemployeeUrl = environment.apiUrl + '/handlers/employeeupdate.php';
  private deleteemployeeUrl = environment.apiUrl + '/handlers/employeedelete.php';

  employees: Employee[] = [];
  selectedEmployee: Employee = {} as Employee;

  constructor(private http: HttpClient) { }

async getEmployees(): Promise<Employee[]> {
    let cuser = localStorage.getItem('currentUser');
    if (cuser === null) {
      throw new Error('Not logged in');
    }
    let user = JSON.parse(cuser);
    let distid = user['distid'];
    const data$ = this.http.post<Employee[]>(this.getemployeecodesUrl,JSON.stringify({ distid: distid }))
    try {
          this.employees = await firstValueFrom(data$);
          return this.employees;
        }
        catch (error) {
          console.error('getemployee service error!', error);
          throw error;
        };  
  }

async create(fname: string, lname: string, employeecode: string, uploaded: string): Promise<any> {
    let cuser = localStorage.getItem('currentUser');
        if (cuser === null) {
          throw new Error('Not logged in');
        }
    let user = JSON.parse(cuser);
    let distid = user['distid'];

    const data$ = this.http.post(this.createemployeeUrl, JSON.stringify({fname,lname,employeecode,uploaded,distid}))
         try {
           let x = await firstValueFrom(data$);
           return x;
         }
         catch (error) {
           console.error(
             'Error in create employee service!', error);
             return;
         };  
  }

     async updateEmployee(fname: string, lname: string, employeecode: string, uploaded: string, id: number): Promise<void> {
        let cuser = localStorage.getItem('currentUser');
        if (cuser === null) {
          throw new Error('Not logged in');
        }
        let user = JSON.parse(cuser);
        let distid = user['distid'];
        try {
          const response$ = await firstValueFrom(this.http.post(this.updateemployeeUrl, JSON.stringify({fname: fname, lname: lname, employeecode:employeecode, uploaded:uploaded,distid:distid,id:id})));
           //return response$;
           return;
        }
        catch (error) {
          console.error(
            'Update Employee Service error!', error);
            throw error;
        };
    }

   async deleteEmployee(id: number): Promise<void> {
        let cuser = localStorage.getItem('currentUser');
        if (cuser === null) {
          throw new Error('Not logged in');
        }
        let user = JSON.parse(cuser);
        let distid = user['distid'];
try 
    {
      const data$ = await this.http.post(this.deleteemployeeUrl,JSON.stringify({id: id, distid: distid }))
      let response = await firstValueFrom(data$);
      return;
    }
    catch (error) 
    {
      console.error(
              'Delete Employee Service Error: ', error);
              throw error;
    };  
   }  
}
